import styled from 'styled-components';

import { WhitePanel } from 'components/Toolkit/WhitePanel/WhitePanel';
import { Button } from 'components/Toolkit/Button/Button';
import { StarOutlineIc } from '@dsch/dd-icons';

import { media } from 'helpers/breakpoints';

export const SWhitePanel = styled(WhitePanel)`
  ${media.large} {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

export const IconAndTextContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing.M16};

  ${media.large} {
    margin-bottom: 0;
  }
`;

export const SStarOutline = styled(StarOutlineIc)`
  height: 40px;
  width: 40px;
  margin-right: ${({ theme }) => theme.spacing.S8};

  ${media.large} {
    margin-right: ${({ theme }) => theme.spacing.M16};
  }
`;

export const SButton = styled(Button)`
  ${media.large} {
    width: 200px;
  }
`;

export const Header = styled.p`
  ${({ theme }) => theme.fontSize.M16};
  color: ${({ theme }) => theme.colors.GREY_DARKER};
  font-weight: ${({ theme }) => theme.fontWeight.bold};

  ${media.large} {
    ${({ theme }) => theme.fontSize.L18};
  }
`;

export const Subtitle = styled.p`
  display: none;

  ${media.large} {
    ${({ theme }) => theme.fontSize.M14};
    display: block;
    color: ${({ theme }) => theme.colors.GREY_DARK};
  }
`;
